import React from 'react'
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { Dashboard, FoodBank, Home } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { RrdLink } from '../controls';


const Panel = ({width = 240, children}) => {
    
    return (
    <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Drawer
            sx={{
            width: width,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
                width: width,
                boxSizing: 'border-box',
            },
            }}
            variant="permanent"
            anchor="left"
        >
            <Toolbar />
            <Divider />
            <List>
                <RrdLink textColor='#000' to='/' >
                    <ListItem button>
                        <ListItemIcon>
                            <Home />
                        </ListItemIcon>
                        <ListItemText primary={'Home'} />
                    </ListItem>
                </RrdLink>
            </List>
            <Divider />
            <List>
                <RrdLink textColor='#000' to='/admin/' >
                    <ListItem button>
                        <ListItemIcon>
                            <Dashboard />
                        </ListItemIcon>
                        <ListItemText primary={'Dashboard'} />
                    </ListItem>
                </RrdLink>
            </List>
            <Divider />
            <List>
                <RrdLink textColor='#000' to='/admin/orders' >
                    <ListItem button>
                        <ListItemIcon>
                            <FoodBank />
                        </ListItemIcon>
                        <ListItemText primary={'Orders'} />
                    </ListItem>
                </RrdLink>
            </List>
            <Divider />
        </Drawer>
        <Box component="main" marginX={2} marginY={4} sx={{ flexGrow: 1, bgcolor: 'background.default' }} >
            {children}
        </Box>

    </Box>
    )
}

export default Panel;